import Vue from 'vue';
import axios from 'axios';
import form from '@/store/modules/register/partials/form.js';
import programMixin from '@/mixins/programMixin.js';

const {getGlobal, arrayCatalogs, getInitialDataPeople, getInitialDocument, getInitialDataPhone, getInitialDataHome} = form;

const state = {
	onlyRead: true,
	loadingCatalog: false,
	loading: false,
	form: {
		...getGlobal()
	},
	catalogs: arrayCatalogs(),
	step: 0,
	loadedProfile: false
};

// Getters
const getters = {
	form(state) {
		return state.form;
	},
	family_members(state) {
		return state.form.a_fellow.person.family_members;
	},
	alias_areas_of_interest(state) {
		return state.form.a_fellow.person.alias_areas_of_interest;
	},
	interest_many(state) {
		return state.form.a_fellow.person.interest_many;
	},
	personLocation(state) {
		return state.form.a_fellow.person.location;
	},
	interestMany(state) {
		return state.form.a_fellow.person.interest_many;
	},
	person(state) {
		return state.form.a_fellow.person;
	},
	isCompleted(state){
		return state.form.a_fellow.person.isCompleted;
	},
	loadedProfile(state){
		return state.loadedProfile;
	},
	catalogs(state) {
		return state.catalogs;
	},
	loadingCatalog(state) {
		return state.loadingCatalog;
	},
	loading(state) {
		return state.loading;
	},
	onlyRead(state) {
		return state.onlyRead;
	},
	step(state) {
		return state.step;
	},
};

// Mutations
const mutations = {
	changeOnlyRead(state, check) {
		state.onlyRead = check;
	},
	changeLoadProfile(state, check){
		state.loadedProfile = check;
	},

	resetStep(state) {
		state.step = 0;
	},
	nextStep(state) {
		if (state.step++ > 6) state.step = 7;
	},
	setStep(state, value) {
		state.step = value;
	},
	before(state) {
		if (state.step > 0) {
			state.step--
		}
	},
	changeLoadingCatalog(state, check) {
		state.loadingCatalog = check;
	},
	changeLoading(state, check) {
		state.loading = check;
	},
	clear(state) {
		// reseteamos la variables
		const ss = state;
		ss.step = 1;
		ss.form = {
			...getGlobal()
		}
	},
	loadCatalogSuccess(state, response) {
		const {data} = response;
		state.catalogs = data;
	},
	addFamily(state) {
		state.form.a_fellow.person.family_members.push({
				relationship_id: null,
				person: getInitialDataPeople()
			}
		);
	},
	removeFamilySuccess(state, payload) {
		let index = state.form.a_fellow.person.family_members.indexOf(payload);
		state.form.a_fellow.person.family_members.splice(index, 1);
	},

	updateDocument(state, payload) {
		let index = state.form.a_fellow.person.documents.indexOf(payload.item);
		Vue.set(state.form.a_fellow.person.documents, index, payload.data);
	},
	updateLocation(state, payload) {
		return state.form.a_fellow.person.location = payload;
	},
	fetchSingleSuccess(state, response, commit) {
		let {data} = response;
		let person = data;
		if(person.isCompleted && (person.isCompleted == 1 && person.isCompleted == true)){
			state.onlyRead = true;
		}else{
			state.onlyRead = false;
		}
		data.isCompleted = person.isCompleted == 1 || person.isCompleted == true ? true : false;
		data.supportAnyIncomeYourHome = person.supportAnyIncomeYourHome == 1 || person.supportAnyIncomeYourHome == true ? true : false;
		data.considerLeavingYourCountry = person.considerLeavingYourCountry == 1 || person.considerLeavingYourCountry == true ? true : false;
		data.knowReadWrite = person.knowReadWrite == 1 || person.knowReadWrite == true ? true : false;




		data.isPersonWithDisability = person.isPersonWithDisability == 1 || person.isPersonWithDisability == true ? true : false;
		data.numberChildren = person.numberChildren != null ? person.numberChildren.toString() : null;
		data.monthlyIncome = person.monthlyIncome == 1 || person.monthlyIncome == true ? true : false;
		data.isHouseHold = person.isHouseHold == 1 || person.isHouseHold == true ? true : false;
		data.isOtherHouseHold = person.isOtherHouseHold == 1 || person.isOtherHouseHold == true ? true : false;
		data.haveYouMigratedFromYourCountry = person.haveYouMigratedFromYourCountry == 1 || person.haveYouMigratedFromYourCountry == true ? true : false;
		data.didYouArriveAtTheDestinationCountry = person.didYouArriveAtTheDestinationCountry == 1 || person.didYouArriveAtTheDestinationCountry == true ? true : false;
		data.doYouHaveRelativesResidingInAnotherCountry = person.doYouHaveRelativesResidingInAnotherCountry == 1 || person.doYouHaveRelativesResidingInAnotherCountry == true ? true : false;
		data.haveYouWorkedInAnotherCountry = person.haveYouWorkedInAnotherCountry == 1 || person.haveYouWorkedInAnotherCountry == true ? true : false;
		data.emigrateAloneOrAccompaniedByRelatives = person.emigrateAloneOrAccompaniedByRelatives != null ? person.emigrateAloneOrAccompaniedByRelatives.toString() : null;
		data.hasFarmRegistry = person.hasFarmRegistry == 1 || person.hasFarmRegistry == true ? true : false;


		//state.form = data;
		const ss = state;
		//ss.step = 1;
		ss.form = {
			...getGlobal()
		};
		ss.form.a_fellow.person = data;

		if(person && (person.isCompleted == 0 && person.isCompleted == false)){
			if (ss.form.a_fellow.person.contact_phones.length == 0) {
				ss.form.a_fellow.person.contact_phones.push({
					...getInitialDataPhone(),
					used_type_id: 1
				});
				ss.form.a_fellow.person.contact_phones.push({
					...getInitialDataPhone(),
					used_type_id: 2
				});
				ss.form.a_fellow.person.contact_phones.push({
					...getInitialDataPhone(),
					used_type_id: 3
				});
			}
			if (ss.form.a_fellow.person.contact_homes.length == 0) {
				ss.form.a_fellow.person.contact_homes.push(
					{...getInitialDataHome()}
				);
			}
			if (!ss.form.a_fellow.person.location) {
				ss.form.a_fellow.person.location = {
					id: null,
					lat: programMixin.methods.isSalvadorProgram() ? 13.446412 : (programMixin.methods.isHondurasProgram() ? 14.8871593 : 0),
					lng: programMixin.methods.isSalvadorProgram() ? -88.528153 :  (programMixin.methods.isHondurasProgram() ? -87.3898346 : 0)
				};
			}

			if (ss.form.a_fellow.person.family_members.length == 0) {

				ss.form.a_fellow.person.family_members.push(
					{
						id: null,
						relationship_id: null,
						person: {
							...getInitialDataPeople()
						}
					});
			}

			if (ss.form.a_fellow.person.documents.length == 0) {
				ss.form.a_fellow.person.documents.push(
					{
						...getInitialDocument(),
						cat_document_type_id: 2
					});

				ss.form.a_fellow.person.documents.push({
					...getInitialDocument(),
					cat_document_type_id: 3
				});

				ss.form.a_fellow.person.documents.push({
					...getInitialDocument(),
					cat_document_type_id: 4
				});
				ss.form.a_fellow.person.documents.push(
					{
						...getInitialDocument(),
						cat_document_type_id: 5
					});

				/*ss.form.a_fellow.person.documents.push(
					{
						...getInitialDocument(),
						cat_document_type_id: 6
					});*/
			}else{
				let arrayTypeDocuments = [2, 3, 4, 5];//, 6
				let loadedTypeDocuments = [];
				ss.form.a_fellow.person.documents.forEach((item)=>{
						loadedTypeDocuments.push(item.cat_document_type_id);
				});
				let diffents = _.differenceWith(arrayTypeDocuments, loadedTypeDocuments, _.isEqual);
				if(diffents && diffents.length>0){
					diffents.forEach((item)=>{
						ss.form.a_fellow.person.documents.push(
							{
								...getInitialDocument(),
								cat_document_type_id: item
							});
					});
				}
			}
		}
		return true;
	}
};

// Actions
const actions = {
	removeFamily({state, commit, dispatch}, payload) {


		let name = payload.person.name ? payload.person.name : '';
		let surName = payload.person.surName ? payload.person.surName : '';
		let secondSurName = payload.person.secondSurName ? payload.person.secondSurName : '';
		let fullName = name + ' ' + surName + ' ' + secondSurName;

		Vue.prototype.$confirm('¿Desea eliminar el famliar: ' + fullName + ' ?').then(confirm => {
			commit('removeFamilySuccess', payload);
		}).catch(e => {
		});

	},
	fetchSigle({state, commit, dispatch},{yongHashId} = {} ) {

		commit('changeLoadProfile', false);



		dispatch('loading/spinner', {msg: 'Cargando Información...', status: true}, {root: true});

		let params = {
			yongHashId
		}

		return axios.get(`/api/young/get-profile`, {params: params})
			.then((res) => {
				dispatch('loading/spinner', {}, {root: true});

				const parsedResponse = res.data;
				if (parsedResponse) {
					commit('fetchSingleSuccess', parsedResponse);

					commit('changeLoadProfile', true);
					return parsedResponse;
				} else {
					return Promise.reject(parsedResponse);
				}

			})
			.catch((err) => {
				console.log(err);
				dispatch('loading/spinner', {}, {root: true});
				let msg = 'No se pudo completar la acción';
				if (err.response &&
					err.response.data &&
					err.response.data.message
					&& err.response.status == 400) {
					msg = err.response.data.message;
				}
				dispatch('notifications/error', {msg: msg}, {root: true});
				return Promise.reject(err);

			});
	},
	storeSave({state, commit, dispatch}, {areasOfInterest} = {}) {
		/*dispatch('loading/spinner', {msg: 'Guardando datos...', status: true}, {root: true});
		let form = Object.assign({}, state.form);
		form.areasOfInterest = areasOfInterest;
		var options = {};
		const url = '/api/register-young';
		options = {
			method: 'POST',
			data: form,
			url: `${url}`
		};


		return axios(options)
			.then((response) => {
				dispatch('loading/spinner', {}, {root: true});
				const parsedResponse = response.data;
				if (parsedResponse && parsedResponse.success == true) {
					return parsedResponse;
				} else {
					return Promise.reject(parsedResponse);
				}
			})
			.catch((err) => {
				dispatch('loading/spinner', {}, {root: true});
				return Promise.reject(err);
			});*/


	},
	loadCatalog({state, commit, dispatch}) {

		let params = {
			countries: true,
			countriesPrograms: true,
			states: true,
			localities: true,
			gender: true,
			jobs: true,
			personDisabilities: true,
			civilStatus: true,
			hightestStudies: true,
			hightestStudiesStatuses: true,
			catStudies: true,
			currencies: true,
			catAreasOfInterest: true,
			catAmountOtherHouseHold: true,
			catRelationships: true,
			catTypeDocuments: true
		};

		let url = '/api/catalog';
		return axios.get(`${url}`, {params: params})

			.then((res) => {
				const parsedResponse = res.data;
				if (parsedResponse) {
					commit('loadCatalogSuccess', parsedResponse);
					return parsedResponse;
				} else {
					return Promise.reject(parsedResponse);
				}
			})
			.catch((err) => {
				dispatch('loading/spinner', {}, {root: true});
				let msg = 'No se pudo completar la acción';
				if (err.response &&
					err.response.data &&
					err.response.data.message
					&& err.response.status == 400) {
					msg = err.response.data.message;
				}
				dispatch('notifications/error', {msg: msg}, {root: true});
				return Promise.reject(err);
			});

	},
	initService({commit, dispatch}) {
		let array_dispatch = [];
		array_dispatch.push(dispatch('loadCatalog'));

		commit('changeLoadingCatalog', true);

		return Promise.all(array_dispatch)
			.then(() => {
				commit('changeLoadingCatalog', false);
			})
			.catch((err) => {
				//dispatch('loading/spinner', {}, {root: true});
				commit('changeLoadingCatalog', false);
				let msg = 'No se pudo completar la acción';
				if (err.response &&
					err.response.data &&
					err.response.data.message
					&& err.response.status == 400) {
					msg = err.response.data.message;
				}
				dispatch('notifications/error', {msg: msg}, {root: true});
				return Promise.reject(err);
			});
	}

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
